import { render, staticRenderFns } from "./VerificationNewDetail.vue?vue&type=template&id=60468756&"
import script from "./VerificationNewDetail.vue?vue&type=script&lang=js&"
export * from "./VerificationNewDetail.vue?vue&type=script&lang=js&"
import style0 from "./VerificationNewDetail.vue?vue&type=style&index=0&id=60468756&prod&lang=css&"
import style1 from "./VerificationNewDetail.vue?vue&type=style&index=1&id=60468756&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports